import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { updateModalProductInfo } from './productinfo.js';
import { throttle } from './throttle.js';

export function initImageGallery() {
    const grid = document.getElementById('images-grid');
    if (!grid) return;

    const filterButtons = document.querySelectorAll('.segments-container .segments-filter .segment-filter-btn');
    const loadMoreBtn = document.getElementById('load-more-images');
    const progressText = document.getElementById('postProgressText');
    const progressBar = document.getElementById('postProgressBar');

    const ITEMS_PER_PAGE = 18;
    let itemsToShow = ITEMS_PER_PAGE;
    let currentSegment = 'all';

    const allItems = Array.from(grid.querySelectorAll('.image-item'));

    function markFilteredItems() {
        let eligible;

        if (currentSegment === 'all') {
            eligible = allItems;
        } else {
            eligible = allItems.filter(item => {
                const segmentsAttr = item.getAttribute('data-segments') || '';
                const segments = segmentsAttr.split(',').map(s => s.trim()).filter(Boolean);
                return segments.includes(currentSegment);
            });
        }

        grid.innerHTML = '';
        eligible.forEach(item => {
            item.classList.remove('filtered-out', 'hidden-by-pagination');
            item.style.display = '';
            grid.appendChild(item);
        });

        return eligible;
    }

    function applyPagination(eligibleItems) {
        const eligible = eligibleItems || Array.from(grid.querySelectorAll('.image-item'));
        let visibleCount = 0;

        eligible.forEach((item, index) => {
            if (index < itemsToShow) {
                item.style.display = '';
                item.classList.remove('hidden-by-pagination');
                visibleCount++;
            } else {
                item.style.display = 'none';
                item.classList.add('hidden-by-pagination');
            }
        });

        if (loadMoreBtn) {
            loadMoreBtn.style.display = visibleCount < eligible.length ? '' : 'none';
        }

        if (progressText && progressBar) {
            progressText.textContent = `Showing ${visibleCount} of ${eligible.length}`;
            const percent = eligible.length > 0 ? (visibleCount / eligible.length) * 100 : 0;
            progressBar.style.width = `${percent}%`;
        }
    }

    function resetAndApply() {
        itemsToShow = ITEMS_PER_PAGE;
        const eligible = markFilteredItems();
        applyPagination(eligible);
    }

    filterButtons.forEach(btn => {
        btn.addEventListener('click', function () {
            filterButtons.forEach(b => b.classList.remove('active'));
            this.classList.add('active');
            currentSegment = this.getAttribute('data-segment') || 'all';
            resetAndApply();
        });
    });

    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', () => {
            itemsToShow += ITEMS_PER_PAGE;
            const eligible = Array.from(grid.querySelectorAll('.image-item'));
            applyPagination(eligible);
        });
    }

    window.addEventListener('resize', throttle(() => {
        const eligible = Array.from(grid.querySelectorAll('.image-item'));
        applyPagination(eligible);
    }, 150));

    resetAndApply();

    const modal = document.getElementById('image-modal');
    if (!modal) return;

    const modalClose = document.getElementById('image-modal-close');
    const modalCloseMobile = document.getElementById('image-modal-close--mobile');
    const modalSwiperWrapper = document.getElementById('modal-swiper-wrapper');

    const modalNextBtns = modal.querySelectorAll('.swiper-button-next');
    const modalPrevBtns = modal.querySelectorAll('.swiper-button-prev');

    const modalSwiper = new Swiper('.modal-swiper', {
        slidesPerView: 1,
        navigation: {
            nextEl: Array.from(modalNextBtns),
            prevEl: Array.from(modalPrevBtns),
        },
        on: {
            slideChange: function () {
                updateModalMetadata(this.activeIndex);
                updateModalButtons(this.activeIndex);
            }
        }
    });

    const updateModalMetadata = (index) => {
        const slide = modalSwiperWrapper.children[index];
        const metaScript = slide.querySelector('.cmp-imagegallery__modal-meta');

        if (metaScript) {
            try {
                const meta = JSON.parse(metaScript.textContent);
                
                // Update product info using shared utility
                updateModalProductInfo(meta, modal);
            } catch (e) {
                console.error('Error parsing modal metadata:', e);
            }
        }
    };

    // Update modal Add-to-Board buttons for active slide
    const updateModalButtons = (index) => {
        const slide = modalSwiperWrapper.children[index];
        if (!slide) return;

        const img = slide.querySelector('img.add-to-board[data-mc-project-board-asset-info]');
        if (!img) return;

        const assetInfo = img.getAttribute('data-mc-project-board-asset-info');
        const buttons = modal.querySelectorAll('[data-flyout-trigger="addToBoard"]');
        buttons.forEach(button => button.setAttribute('data-asset-info', assetInfo));
    };

    grid.querySelectorAll('.cmp-imagescrollgallery__card-image').forEach((img, index) => {
        img.addEventListener('click', () => {
            modal.removeAttribute('hidden');
            modalSwiper.slideTo(index);
            updateModalMetadata(index);
            updateModalButtons(index);
        });
    });

    modalClose?.addEventListener('click', () => {
        modal.setAttribute('hidden', 'true');
    });

    modalCloseMobile?.addEventListener('click', () => {
        modal.setAttribute('hidden', 'true');
    });
}
